import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Moon, Sun } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { WannaPublishLockup } from '../editor/WannaPublishLogo';
import { Button } from '../ui/button';

/** The short header shared by the pages outside the editor (subscribe, checkout return): wordmark, theme, who is signed in, sign out. */
export const SiteHeader = ({ theme, onToggleTheme, testId = 'site-header' }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const doSignOut = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await signOut();
      toast.success('Signed out', { id: 'auth' });
      navigate('/', { replace: true });
    } finally { setBusy(false); }
  };

  return (
    <header className="shrink-0 w-full max-w-[1480px] mx-auto px-3 sm:px-6 h-[72px] sm:h-[88px] flex items-center justify-between gap-3" data-testid={testId}>
      <a href="/" className="flex items-center gap-2.5 min-w-0 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" data-testid={`${testId}-brand`}>
        <WannaPublishLockup size={52} className="shrink-0 sm:hidden" />
        <WannaPublishLockup size={64} className="shrink-0 hidden sm:block" />
      </a>
      <div className="flex items-center gap-2 shrink-0 min-w-0">
        {user && <span className="hidden sm:inline text-sm text-muted-foreground truncate max-w-[280px]" data-testid={`${testId}-signed-in-as`}>Signed in as <span className="text-foreground font-medium">{user.email}</span></span>}
        <Button type="button" variant="ghost" size="icon" className="h-10 w-10" onClick={onToggleTheme} aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} title={theme === 'dark' ? 'Light mode' : 'Dark mode'} data-testid={`${testId}-theme-toggle`}>{theme === 'dark' ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}</Button>
        {user && (
          <Button type="button" variant="outline" className="h-10 px-4 text-sm" onClick={doSignOut} disabled={busy} data-testid={`${testId}-sign-out`}>
            <LogOut className="h-4 w-4 mr-2" aria-hidden="true" />{busy ? 'Signing out…' : 'Sign out'}
          </Button>
        )}
      </div>
    </header>
  );
};
